const membershipUnredeemableInfoDirective = function (
) {
    return {
        restrict: 'E',
        scope: {
            alertClasses: '@',
            membership: '=',
            subscription: '=',
        },
        templateUrl: 'partials/directives/dt-membership-unredeemable-info.html',
    };
};

module.exports = membershipUnredeemableInfoDirective;
